import { LOGIN_SUCCESS } from '../reducers/auth';

export function receiveLogin({ id_token: idToken, profile }) {
  return {
    type: LOGIN_SUCCESS,
    id_token: idToken,
    profile,
  };
}
